<div #ggcScaleLine class="ggc-scale-line"></div>
